import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {MotifAccordPrealableTableListeRestApiService} from './motif-accord-prealable-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class MotifAccordPrealableTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: MotifAccordPrealableTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
